<template>
  <div class="stars">
    <div v-for="(val, index) in rateArray" :key="index" class="star">
      <i class="icon-star-bordered not-fill"></i>
      <i class="icon-star2 fill" :style="{width: val}"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "StarRating",
  data() {
    return {
      rateArray: this.rateParser(),
    };
  },
  props: ["rate"],
  methods: {
    rateParser() {
      // rate number to array of percents
      let a = [];

      for (var i = 1; i <= 5; i++) {
        if (this.rate >= i) {
          a.push("100%");
        } else if (this.rate >= i - 1) {
          a.push(parseInt((this.rate - parseInt(this.rate)) * 100) + "%");
        } else {
          a.push("0%");
        }
      }

      return a;
    },
  },
};
</script>